import ReactPlayer from 'react-player';
import './RegularVideo.css'
import { Tweet } from 'react-tweet'

function extractTweetId(twitterLink) {
    // Updated regular expression to match both old and new Twitter URLs
    const regex = /^(?:https?:\/\/)?(?:mobile\.|www\.)?x\.com\/([^\/]+)\/status\/(\d+)$/;
    const match = twitterLink.match(regex);
  
    if (match && match.length > 2) {
      return match[2]; // Extract the captured group (tweet ID)
    } else {
      return null; // No tweet ID found
    }
  }

function RegularVideo({url, videoSource}) {
    switch (videoSource)
    {
        case 'bilibili':
            return (
                <div className='player-wrapper'
                    sx={{
                        width: 'auto', // Reset width
                        height: 'auto',
                    }}
                >
                    <iframe
                        src={url} 
                        border="0" frameborder="no" framespacing="0" allowfullscreen="true"
                        controls={true}
                        playing={false}
                        className="react-player"
                    />
                </div>
            );
        case 'x':
            let tweetId = extractTweetId(url);
            return (
                <div 
                    sx={{width: 'auto',height: 'auto',}}
                >
                    <Tweet 
                        id={tweetId}
                    />
                </div>
                
            )
        default:
            return (
                <div className='player-wrapper'
                    sx={{width: 'auto',height: 'auto',}}
                >
                    <ReactPlayer
                        url={url}
                        controls={true}
                        playing={false}
                        loop={false}
                        width="100%"
                        height="100%"
                        className="react-player"
                    />
                </div>
            );
    }
}

export default RegularVideo;